import { CategorySwatchIcon } from "@clockwise/design-system/src/components/Icons/CategorySwatch";
import { bg_info_emphasis } from "@clockwise/design-system/tokens";
import { ChevronRight, Sell } from "@clockwise/icons";
import {
  CategoryOption,
  sortByLabel,
} from "@clockwise/web-commons/src/components/module-category-picker/CategoryPickerModule";
import { Category } from "@clockwise/web-commons/src/hooks/useEventCategory";
import { Skeleton } from "@material-ui/lab";
import { debounce, noop } from "lodash";
import { default as React, useState } from "react";
import { InteractiveTooltip } from "../../../interactive-tooltip";
import { ListItemButton } from "../../calendar-popover/atoms/ListItemButton";

export const EventCategory = ({
  loading,
  category,
  categoryOptions,
  onChange,
}: {
  category: Category;
  categoryOptions: Category[];
  loading: boolean;
  onChange: (category: CategoryOption) => void;
}) => {
  const [tooltipOpen, _setTooltipOpen] = useState(false);

  const setTooltipOpenDebounced = debounce((isOpen: boolean) => {
    _setTooltipOpen(isOpen);
  }, 150);

  const setTooltipOpen = (isOpen: boolean) => {
    if (isOpen) {
      _setTooltipOpen(isOpen);
    }

    setTooltipOpenDebounced(isOpen);
  };

  if (loading)
    return (
      <div className="cw-py-1 cw-my-1 cw-px-1 cw-flex cw-items-center cw-gap-2">
        <Skeleton variant="circle" height={16} width={16} className="cw-ml-[2px]" />
        <Skeleton variant="rect" height={24} className="cw-flex-grow cw-rounded-md" />
      </div>
    );

  return (
    <>
      <InteractiveTooltip
        open={tooltipOpen}
        title={
          <div
            cw-id="event-category-portal"
            className="cw-rounded-xl cw-w-[230px] cw-overflow-auto cw-body-sm cw-text-12 cw-bg-default cw-shadow-selectPopup cw-px-1 cw-py-2"
            onMouseOver={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
          >
            {categoryOptions.sort(sortByLabel).map((option) => {
              return (
                <ListItemButton
                  key={option.label}
                  onClick={() => {
                    onChange(option);
                  }}
                  keepHoveredStyle={category.value === option.value}
                >
                  <div className="cw-flex cw-flex-row cw-items-center">
                    <CategorySwatchIcon
                      className="cw-w-4 cw-h-4 cw-mr-2"
                      fill={option.color || bg_info_emphasis}
                    />
                    {option.label}
                  </div>
                </ListItemButton>
              );
            })}
          </div>
        }
      >
        <div
          onMouseOver={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)}
          onFocus={() => setTooltipOpen(true)}
          onBlur={() => setTooltipOpen(false)}
        >
          <ListItemButton startIcon={Sell} endIcon={ChevronRight} onClick={noop}>
            Event category
          </ListItemButton>
        </div>
      </InteractiveTooltip>
    </>
  );
};
